import React, { useState } from "react";
import styled from "styled-components";

// Import images
import photo1 from "../PhotosGallery/photo1.jpg";
import photo2 from "../PhotosGallery/photo2.jpg";
import photo3 from "../PhotosGallery/photo3.jpg";
import photo4 from "../PhotosGallery/photo4.jpg";
import photo5 from "../PhotosGallery/photo5.jpg";
import photo6 from "../PhotosGallery/photo6.jpg";
import photo7 from "../PhotosGallery/photo7.jpg";
import photo8 from "../PhotosGallery/photo8.jpg";

const images = [photo1, photo2, photo3, photo4, photo5, photo6, photo7, photo8];

// Grid layout for images
const GalleryContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(200px, 1fr)
  ); // Creates responsive columns
  gap: 20px; // Space between thumbnails
  padding: 40px;
   
  min-height: 100vh; // Ensures full height of viewport
  color: darkgoldenrod;

  
   

   @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  }
`;

// Circle style for each image in the grid
const Thumbnail = styled.img`
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2); // Adjusted scale
  }
  @media (max-width: 768px) {
    width: 40vw; // Adjust size for mobile
  }
`;

// Overlay for enlarged image view
interface OverlayProps {
  isOpen: boolean;
}

const Overlay = styled.div<OverlayProps>`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

// Styling for enlarged image container
const LargeImageContainer = styled.div`
  position: relative;
  max-width: 80%;
  max-height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;

   @media (max-width: 768px) {
    max-width: 80%;
  }
`;

// Styling for enlarged image
const LargeImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 600px;
  max-height: 600px;
  border-radius: 10px;
`;

// Arrow button styles
const ArrowButton = styled.button<{ direction: string }>`
  position: absolute;
  top: 50%;
  ${({ direction }) => direction}: -40px; // Position outside the image
  background: darkgoldenrod;
  border: none;
  font-size: 2.5rem;
  color: #2e2e2e;
  cursor: pointer;
  transform: translateY(-50%);
  padding: 10px;
  border-radius: 50%;
  &:hover {
    background: gold;
  }
`;

const Gallery: React.FC = () => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handlers for navigation and closing overlay
  const openOverlay = (index: number) => {
    setCurrentIndex(index);
    setIsOverlayOpen(true);
  };

  const closeOverlay = () => {
    setIsOverlayOpen(false);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div>
      <GalleryContainer>
        {images.map((image, index) => (
          <Thumbnail
            key={index}
            src={image}
            alt={`Gallery Image ${index + 1}`}
            onClick={() => openOverlay(index)}
          />
        ))}
      </GalleryContainer>

      {/* Overlay for enlarged view */}
      <Overlay isOpen={isOverlayOpen} onClick={closeOverlay}>
        <LargeImageContainer onClick={(e) => e.stopPropagation()}>
          <ArrowButton direction="left" onClick={handlePrev}>
            &lt;
          </ArrowButton>
          <LargeImage
            src={images[currentIndex]}
            alt={`Enlarged Image ${currentIndex + 1}`}
          />
          <ArrowButton direction="right" onClick={handleNext}>
            &gt;
          </ArrowButton>
        </LargeImageContainer>
      </Overlay>
    </div>
  );
};

export default Gallery;
